import { keyframes } from '@emotion/core';

export const slideInRightAnimation = keyframes`
    from {
        transform: translateX(90%);
        opacity: 0;
    }

    to {
        transform: translateX(0);
        opacity: 1;
    }
`;

export default slideInRightAnimation;
